// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"cdd1d029","147":"2023deac","417":"61179654","727":"f65b4431","747":"66685539","893":"5618833a","914":"bfb354b6","956":"0415b283","997":"daa35480"}[chunkId] + ".chunk.css";
};